// extracted by mini-css-extract-plugin
export default {"Wrapper":"MfaStrategyRadioButton_Wrapper__fa1-0","Radio":"MfaStrategyRadioButton_Radio__mUqYm"};